"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = require("../base");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PointLayerIcon = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PointLayerIcon, _Component);

  var _super = _createSuper(PointLayerIcon);

  function PointLayerIcon() {
    (0, _classCallCheck2["default"])(this, PointLayerIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PointLayerIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base.Base, this.props, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "29.4",
        cy: "31.6",
        r: "8.4",
        className: "cr1"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "48.5",
        cy: "15.7",
        r: "6.5",
        className: "cr2"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "11",
        cy: "44.2",
        r: "3",
        className: "cr3"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "50",
        cy: "44.2",
        r: "5",
        className: "cr4"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "34",
        cy: "54.2",
        r: "3",
        className: "cr5"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "14",
        cy: "16.2",
        r: "4",
        className: "cr6"
      }));
    }
  }]);
  return PointLayerIcon;
}(_react.Component);

(0, _defineProperty2["default"])(PointLayerIcon, "propTypes", {
  height: _propTypes["default"].string,
  colors: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
(0, _defineProperty2["default"])(PointLayerIcon, "defaultProps", {
  height: '16px',
  predefinedClassName: 'point-layer-icon',
  totalColor: 6
});
var _default = PointLayerIcon;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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